/**
 * @typedef {Object} OfficerItem
 * @property {string} name - The unique name for the field.
 * @property {string} label - The display label for the field.
 * @property {string} placeholder - The display placeholder for the field.
 * @property {Object} [error=null] - Object containing validation error.
 */

const addressFormFields = (errors) => [
  {
    key: 5,
    name: "address1",
    label: "",
    placeholder: "Address 1",
    error: errors.address1,
  },
  {
    key: 6,
    name: "address2",
    label: "",
    placeholder: "Address 2",
    error: errors.address2,
  },
  {
    key: 7,
    name: "town",
    label: "",
    placeholder: "Town",
    error: errors.town,
  },
  {
    key: 8,
    name: "postcode",
    label: "",
    placeholder: "Postcode",
    error: errors.postcode,
  },
];

const stationNameField = (officerType, errors) =>
  !officerType || officerType === 1
    ? [
        {
          key: 3,
          name: "stationName",
          label: "Station Name",
          placeholder: "Enter officer's station name...",
          error: errors.stationName,
        },
      ]
    : [];

const phoneNumberLabel = (officerType) =>
  !officerType || officerType === 1
    ? "Station Contact Number"
    : "Contact Number";

const officerFormFields = (officerType, errors) => [
  {
    key: 1,
    name: "name",
    label: "Officer Name",
    placeholder: "Enter officer's name (e.g. Bill Harris)",
    error: errors.name,
  },
  {
    key: 2,
    name: "badgeNumber",
    label: "Officer Badge Number",
    placeholder: "Enter officer's badge number...",
    error: errors.badgeNumber,
  },
  ...stationNameField(officerType, errors),
  {
    key: 4,
    name: "phoneNumber",
    label: phoneNumberLabel(officerType),
    placeholder: "Enter officer's station contact number...",
    error: errors.phoneNumber,
  },
];

/**
 * An array of items for the select component.
 * @param {function} errors -  Errors function from react-hook-form
 * @returns {{ officerForm: OfficerItem[], addressForm: OfficerItem[] }} - The return objects
 */
export const mapOfficerFormOptions = ({ officerType = null, errors }) => {
  const officerForm = officerFormFields(officerType, errors);
  const addressForm = addressFormFields(errors);
  return { officerForm, addressForm };
};
